/**
 * Built-in page covers: CSS mesh gradients, so they work offline, need no
 * assets and stay readable with any palette. `spec.cover` stores the name.
 */
export const COVERS = {
  aurora: {
    label: 'Aurora',
    css: 'radial-gradient(60% 90% at 70% 20%, #f0abfc 0%, transparent 60%), radial-gradient(50% 80% at 30% 90%, #6366f1 0%, transparent 60%), radial-gradient(40% 60% at 90% 80%, #ec4899 0%, transparent 60%), linear-gradient(120deg, #1e1b4b 0%, #4c1d95 50%, #0f172a 100%)',
  },
  sunset: {
    label: 'Sunset',
    css: 'radial-gradient(60% 90% at 20% 30%, #fb923c 0%, transparent 60%), radial-gradient(50% 70% at 80% 80%, #f43f5e 0%, transparent 60%), linear-gradient(110deg, #7c2d12 0%, #9f1239 60%, #1e1b4b 100%)',
  },
  ocean: {
    label: 'Ocean',
    css: 'radial-gradient(60% 90% at 80% 20%, #38bdf8 0%, transparent 60%), radial-gradient(50% 70% at 20% 90%, #2dd4bf 0%, transparent 60%), linear-gradient(120deg, #0c4a6e 0%, #134e4a 60%, #0f172a 100%)',
  },
  meadow: {
    label: 'Meadow',
    css: 'radial-gradient(60% 90% at 30% 20%, #a3e635 0%, transparent 60%), radial-gradient(50% 70% at 80% 90%, #34d399 0%, transparent 60%), linear-gradient(120deg, #14532d 0%, #365314 60%, #0f172a 100%)',
  },
  ember: {
    label: 'Ember',
    css: 'radial-gradient(50% 80% at 70% 30%, #fbbf24 0%, transparent 55%), radial-gradient(40% 60% at 20% 80%, #f97316 0%, transparent 60%), linear-gradient(120deg, #1c1917 0%, #451a03 60%, #0f0a05 100%)',
  },
  dusk: {
    label: 'Dusk',
    css: 'radial-gradient(60% 80% at 70% 80%, #a78bfa 0%, transparent 60%), radial-gradient(50% 70% at 20% 20%, #fda4af 0%, transparent 60%), linear-gradient(120deg, #312e81 0%, #4a044e 60%, #0f172a 100%)',
  },
  mist: {
    label: 'Mist',
    css: 'radial-gradient(60% 90% at 30% 30%, #e2e8f0 0%, transparent 60%), radial-gradient(50% 70% at 80% 80%, #94a3b8 0%, transparent 60%), linear-gradient(120deg, #cbd5e1 0%, #64748b 100%)',
  },
  graphite: {
    label: 'Graphite',
    css: 'radial-gradient(50% 80% at 80% 20%, #475569 0%, transparent 60%), linear-gradient(120deg, #0f172a 0%, #1e293b 60%, #020617 100%)',
  },
} as const

export type CoverName = keyof typeof COVERS

export const coverCss = (name: string | undefined): string | undefined =>
  name && name in COVERS ? COVERS[name as CoverName].css : undefined
